import { Card, DataTable, Text } from "@shopify/polaris";

import type { DashboardSummary } from "../types";

import { t } from "../lib/i18n";

interface Props {
  rows: DashboardSummary["top_sellers"];
  windowDays: number;
  /**
   * 同期が一度でも完了しているか。
   * 🔴 空表の意味が正反対になる＝未同期は「まだ読み込んでいない」、同期済みは
   * 「この期間に売れた商品が本当に無い」。区別せずに後者だけ出すと、初日の店に
   * 「売れていない」と告げることになる（X6）。
   */
  hasSynced: boolean;
}

export function TopSellersTable({ rows, windowDays, hasSynced }: Props) {
  if (rows.length === 0) {
    return (
      <Card>
        <Text as="p" variant="bodyMd" tone="subdued">
          {hasSynced
            ? t("直近 {days} 日間に売れた商品はありません（同期は完了しています）。", {
                days: windowDays,
              })
            : t("まだ同期していません。上の「今すぐ同期」を押すと、商品と注文を読み込みます。")}
        </Text>
      </Card>
    );
  }
  return (
    <Card padding="0">
      <DataTable
        columnContentTypes={["text", "text", "numeric"]}
        headings={["SKU", t("商品名"), t("売上数量（直近 {days} 日）", { days: windowDays })]}
        rows={rows.map((r) => [
          r.sku ?? "—",
          r.title ?? "—",
          r.total_quantity.toLocaleString(),
        ])}
      />
    </Card>
  );
}
